module.exports = "/images/Loja-integrada_v2.png?fa1270d0b55cfa5f83c994533d102f44";